import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import moment from "moment";
import 'moment/locale/es';
import { useDispatch } from 'react-redux';
import PrivateRoute from './private-route';
import AppComponent from './AppContainer';
import Calendar from './calendar';
import { setCustomerConnectEmail } from './actions/lexon';
import { resetBackendRequestsState } from './services/state';
import UserLexon from './components/user-lexon/UserLexon';
import UserCalendar from './components/user-lexon/UserCalendar';
import Login from './components/login/login';
import ErrorScreen from './components/error/error';
import CookieBotPolicy from './components/cookie-bot/CookieBotPolicy';
import './styles/main.scss';


const App = () => {
  const [appConnectEmail, setAppConnectEmail] = useState(null);
  const [isFrame, setIsFrame] = useState(false);
  const dispatch = useDispatch();
  moment.locale('es');

  useEffect(() => {
    const search = window.location.search;
    const email = new URLSearchParams(search).get('appConnectMail');
    setAppConnectEmail(email);
    setIsFrame(window !== window.top);
    dispatch(setCustomerConnectEmail(email));
    resetBackendRequestsState(dispatch);
  }, [dispatch]);

  return (
    <Router basename='/'>
      <Routes>
        <Route path='/politica-de-cookies' element={<CookieBotPolicy />} />
        <Route path='/access/:token' element={<UserLexon />} />
        <Route path='/user/:idUser/folder/:idFolder/message/:idMessage/casefile/:idCaseFile/bbdd/:bbdd' element={<UserLexon />} />
        <Route path='/user/:idUser/folder/:idFolder/message/:idMessage/bbdd/:bbdd' element={<UserLexon />} />
        <Route path='/user/:idUser/casefile/:idCaseFile/bbdd/:bbdd' element={<UserLexon />} />
        <Route path='/user/:idUser/contacts/:mailContacts/bbdd/:bbdd' element={<UserLexon />} />
        <Route path='/user/:idUser/bbdd/:bbdd' element={<UserLexon />} />
        <Route path='/user/:idUser' element={<UserLexon />} />
        <Route path='/calendar/user/:idUser' element={<UserCalendar />} />
        <Route path='/calendar/access/:token' element={<UserCalendar />} />
        <Route path='/calendar' element={<Calendar />} />
        <Route path='/login' element={<Login />} />
        <Route path='/error/:id' element={<ErrorScreen />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              {isFrame && !appConnectEmail ? (
                <Calendar />
              ) : (
                <AppComponent location={window.location} />
              )}
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
